<div class="minor-account-invite">
  <div *ngIf="!ready">
    <se-fe-spinner
      [seFeDataSize]="900"
      [seFeDataInverted]="false"
      [seFeDataCenter]="true"
    ></se-fe-spinner>
  </div>

  <ng-container *ngIf="ready">
    <div class="minor-account-invite-icon">
      <se-fe-icon
        seFeDataName="spot_safety"
        seFeDataSize="950"
        seFeDataAriaLabel="safety"
        [seFeDataMargin]="false"
      ></se-fe-icon>
    </div>
    <div class="minor-account-invite-title">
      <se-po-highlight-label
        label="Get help from a parent"
      ></se-po-highlight-label>
    </div>
    <div class="minor-account-invite-body">
      <p>
        Upon review, your account is ineligible.
        SportsEngine is designed for parents and guardians to manage
        their children's sports activities.
      </p>
      <p>
        Input a parent or guardian's email to have them manage your account.
      </p>
    </div>
    <div role="content" class="minor-account-invite-content">
      <form
        *ngIf="ready"
        [formGroup]="form"
        (ngSubmit)="validateAndSubmit()"
        novalidate>

        <section>
          <se-po-email
            seFeDataLabel="Enter Parent's Email"
            formControlName="emailAddress">
          </se-po-email>
        </section>

        <div class="form-submit">
          <se-fe-button
            seFeDataEmphasis="high"
            seFeDataType="submit"
            [seFeDataIsLoading]="submitting"
            [seFeDataFullWidth]="true">Continue</se-fe-button>
        </div>
      </form>
    </div>
  </ng-container>
</div>
